(function () {
  const dataTarget = document.currentScript.dataset.target;
  const hotSpotsContainer = document.querySelector(dataTarget);

  const hotSpotSwiper = hotSpotsContainer.querySelector('.hot-spot__swiper');
  const productListSwiper = hotSpotsContainer.querySelector('.hot-spot__product-swiper');
  const pagination = hotSpotsContainer.querySelector('.hot-spots__pagination');

  const swiper = new Swiper(hotSpotSwiper, {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });

  const secondSwiper = new Swiper(productListSwiper, {
    autoHeight: true,
    spaceBetween: 10,
    thumbs: {
      swiper: swiper,
    },
    pagination: {
      el: pagination,
      clickable: true
    },
  });

  hotSpotSwiper.querySelectorAll('.swiper-slide-thumb').forEach((thumb, index) => {
    thumb.addEventListener('mouseenter', function () {
      secondSwiper.slideTo(index);
    });
  });
})();
